import Vue from 'vue';
import axios from 'axios';

let download = function (url, params, fileName){
    axios({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob',
        dataType: 'application/json;charset=UTF-8;',
        timeout : 9999999
    }).then(response => {
        htmlDownload(response, fileName)
    }).catch((error) => {
        console.error(error)
    })
}

let htmlDownload = function(downData, fileName){
    if (!downData) {
        return;
    }
    let timestamp = Date.parse(new Date());
    timestamp = timestamp + "";
    if(!fileName){
        fileName = timestamp + '.xlsx';
    }else{
        fileName += '.xlsx';
    }
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = window.URL.createObjectURL(new Blob([downData]))
    link.setAttribute('download', fileName);
    link.setAttribute('class', "");
    document.body.appendChild(link)
    link.click()
    link.remove();
}


// 添加到 Vue原型链
Vue.prototype.$download = download;



// WEBPACK FOOTER //
// ./src/utils/download.js